/* Dozzz buy box - stepper + per-mask colour slots + Shopify cart add.
   Supports two styles (flat / threed) with a toggle, in-stock-only colours,
   and per-colour stock caps for small-batch ranges.
   NB: 3D data attributes are read via getAttribute because names like
   data-tier2-3d do NOT camelCase into dataset (dash before a digit). */
(function () {
  const root = document.querySelector('.dz-buybox');
  if (!root) return;

  const attr = name => root.getAttribute(name);
  const readJSON = sel => { const el = document.querySelector(sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } };

  function buildStyle(key) {
    const is3d = key === 'threed';
    const raw = readJSON(is3d ? '[data-dz-variants-3d]' : '[data-dz-variants]');
    if (!raw) return null;
    /* only in-stock colours render; qty=null means untracked (no cap) */
    const variants = raw.filter(v => v.available && (v.qty === null || v.qty > 0));
    if (!variants.length) return null;
    const media = readJSON(is3d ? '[data-dz-media-3d]' : '[data-dz-media]') || [];
    const views = {};
    variants.forEach(v => {
      views[v.name] = [{ src: v.image, thumb: v.thumb || v.image, label: 'Front' }];
      media.forEach(m => {
        const parts = (m.alt || '').split('|');
        if (parts.length > 1 && parts[0].trim().toLowerCase() === v.name.toLowerCase()) {
          views[v.name].push({ src: m.src, thumb: m.thumb, label: parts.slice(1).join('|').trim() || 'View' });
        }
      });
      /* fallback: no variant image - use first product image whose alt mentions the colour */
      if (!views[v.name][0].src) {
        const match = media.find(m => (m.alt || '').toLowerCase().includes(v.name.toLowerCase()));
        if (match) { views[v.name][0].src = match.src; views[v.name][0].thumb = match.thumb; }
      }
    });
    const base = parseFloat(is3d ? attr('data-base-price-3d') : attr('data-base-price'));
    const tiers = [
      { qty: 1, each: base, name: 'Single mask', sub: 'Just for you' },
      { qty: 2, each: parseFloat(is3d ? attr('data-tier2-3d') : attr('data-tier2')), name: 'Wear one, wash one', sub: 'Silk needs both' },
      { qty: 3, each: parseFloat(is3d ? attr('data-tier3-3d') : attr('data-tier3')), name: 'The Household Set', sub: 'Most popular', flag: 'popular' },
      { qty: 4, each: parseFloat(is3d ? attr('data-tier4-3d') : attr('data-tier4')), name: 'The Gift Set', sub: 'One for everyone', flag: 'best' }
    ].map(t => ({ ...t, save: Math.round((1 - t.each / base) * 100) }));
    const defaults = ((is3d ? attr('data-default-colours-3d') : attr('data-default-colours')) || '').split(',').map(s => s.trim()).filter(Boolean);
    const capacity = variants.reduce((sum, v) => (sum === Infinity || v.qty === null) ? Infinity : sum + v.qty, 0);
    return { key: key, variants: variants, views: views, base: base, tiers: tiers, defaults: defaults, capacity: capacity };
  }

  const STYLES = { flat: buildStyle('flat'), threed: buildStyle('threed') };
  if (!STYLES.flat && !STYLES.threed) return;
  const firstStyle = STYLES.flat ? 'flat' : 'threed';

  const state = { style: firstStyle, qty: parseInt(attr('data-default-qty'), 10) || 2, slots: [], active: 0, view: 0, galleryColour: null };
  const S = () => STYLES[state.style];

  const $ = sel => root.querySelector(sel);
  const fmt = n => '\u00a3' + n.toFixed(2);
  const tier = () => S().tiers.find(t => t.qty === state.qty);
  const byName = name => S().variants.find(v => v.name === name);
  const byNameSafe = name => S().variants.find(v => v.name.toLowerCase() === String(name).toLowerCase());
  const silkBg = hex => `radial-gradient(circle at 32% 28%, rgba(255,255,255,.55), rgba(255,255,255,0) 42%), linear-gradient(145deg, ${hex} 0%, ${hex} 55%, rgba(0,0,0,.25) 100%), ${hex}`;
  const MASK = hex => `<svg viewBox=\"0 0 400 220\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30 90 Q60 30 200 34 Q340 30 370 90 Q385 130 340 165 Q300 196 245 180 Q215 170 200 148 Q185 170 155 180 Q100 196 60 165 Q15 130 30 90 Z\" fill=\"${hex}\"/><path d=\"M60 70 Q200 46 340 70\" fill=\"none\" stroke=\"rgba(255,255,255,.35)\" stroke-width=\"10\" stroke-linecap=\"round\"/></svg>`;

  /* ---- stock caps ---- */
  const capOf = v => (v.qty === null ? Infinity : v.qty);
  function canAssign(name, slots, excludeIndex) {
    const v = byName(name); if (!v) return false;
    let used = 0;
    slots.forEach((c, i) => { if (i !== excludeIndex && c === name) used++; });
    return used < capOf(v);
  }
  function pickDefault(slots, slotIndex) {
    const prefs = S().defaults.map(n => byNameSafe(n)).filter(Boolean).map(v => v.name);
    const order = prefs.concat(S().variants.map(v => v.name));
    if (order[slotIndex] && canAssign(order[slotIndex], slots, -1)) return order[slotIndex];
    for (const n of order) { if (canAssign(n, slots, -1)) return n; }
    return S().variants[0].name;
  }
  const maxQty = () => Math.min(S().tiers.length, S().capacity === Infinity ? S().tiers.length : Math.max(1, S().capacity));

  function fillSlots(q, preferred) {
    const slots = [];
    if (preferred && byNameSafe(preferred) && canAssign(byNameSafe(preferred).name, slots, -1)) slots.push(byNameSafe(preferred).name);
    while (slots.length < q) slots.push(pickDefault(slots, slots.length));
    return slots.slice(0, q);
  }

  /* URL preselect: ?colour=navy or ?variant=ID (flat only) */
  (function () {
    const p = new URLSearchParams(location.search);
    const c = p.get('colour'), v = p.get('variant');
    let first = null;
    if (c) first = S().variants.find(x => x.name.toLowerCase().replace(/\s+/g, '-') === c.toLowerCase());
    if (!first && v) first = S().variants.find(x => String(x.id) === v);
    state.qty = Math.min(state.qty, maxQty());
    state.slots = fillSlots(state.qty, first ? first.name : null);
    state.galleryColour = state.slots[0];
  })();

  function setStyle(key) {
    if (!STYLES[key] || state.style === key) return;
    state.style = key;
    state.qty = Math.min(parseInt(attr('data-default-qty'), 10) || 2, maxQty());
    state.slots = fillSlots(state.qty, null);
    state.active = 0; state.view = 0;
    state.galleryColour = state.slots[0];
    const tog = document.querySelector('[data-dz-styles]');
    if (tog) tog.querySelectorAll('.dz-style').forEach(b => {
      const on = b.dataset.style === key;
      b.classList.toggle('dz-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    const nudge = document.querySelector('[data-dz-nudge]');
    if (nudge) {
      const txt = key === 'threed' ? nudge.getAttribute('data-nudge-3d') : nudge.getAttribute('data-nudge-flat');
      const span = nudge.querySelector('[data-dz-nudge-text]');
      if (span) span.textContent = txt || '';
      nudge.style.display = txt ? '' : 'none';
    }
    render();
  }

  function setQty(q) {
    state.qty = Math.min(maxQty(), Math.max(1, q));
    while (state.slots.length < state.qty) state.slots.push(pickDefault(state.slots, state.slots.length));
    state.slots = state.slots.slice(0, state.qty);
    render();
  }

  function renderStepper() {
    const t = tier();
    const BASE = S().base;
    $('[data-dz-icons]').innerHTML = state.slots.map(n => MASK(byName(n).hex)).join('');
    $('[data-dz-count]').textContent = `${t.qty} mask${t.qty > 1 ? 's' : ''}`;
    $('[data-dz-minus]').disabled = t.qty <= 1;
    $('[data-dz-plus]').disabled = t.qty >= maxQty();

    const flag = t.flag === 'best' ? '<span class=\"dz-flag\">Biggest saving</span>' : t.flag === 'popular' ? '<span class=\"dz-flag dz-popular\">Most popular</span>' : '';
    const saving = (BASE - t.each) * t.qty;
    const FREE_QTY = parseInt(attr('data-free-delivery-qty'), 10) || 2;
    $('[data-dz-price-card]').innerHTML = `${flag}
      <div><div class=\"dz-pc-name\">${t.name}</div><div class=\"dz-pc-sub\">${t.qty} delivered in gift boxes${t.qty >= FREE_QTY ? ' - free UK delivery' : ''}</div></div>
      <div class=\"dz-pc-price\">
        ${t.save ? `<div class=\"dz-pc-was\">${fmt(BASE)}</div>` : ''}
        <div class=\"dz-pc-each\">${fmt(t.each)}<span>/mask</span></div>
        ${t.save ? `<div class=\"dz-pc-save\">Save ${fmt(saving)} (${t.save}%)</div>` : `<div class=\"dz-pc-save dz-pc-save--muted\">Add one more to save ${fmt(BASE - S().tiers[1].each)}</div>`}
      </div>`;

    const mq = maxQty();
    $('[data-dz-ladder]').innerHTML = S().tiers.map(x => `<button type=\"button\" class=\"${x.qty === state.qty ? 'dz-on' : ''}\" data-qty=\"${x.qty}\" ${x.qty > mq ? 'disabled' : ''}><b>${x.qty}</b>${x.save ? '-' + x.save + '%' : 'full price'}</button>`).join('');
    $('[data-dz-ladder]').querySelectorAll('button:not([disabled])').forEach(b => b.addEventListener('click', () => setQty(parseInt(b.dataset.qty, 10))));
  }

  function renderSlots() {
    $('[data-dz-slots]').innerHTML = state.slots.map((chosen, i) => `
      <div class=\"dz-slot\">
        <div class=\"dz-slot-head\"><span class=\"dz-slot-title\">Mask ${i + 1}</span><span class=\"dz-slot-chosen\">${chosen}</span></div>
        <div class=\"dz-swatches\" role=\"radiogroup\" aria-label=\"Colour for mask ${i + 1}\">
          ${S().variants.map(v => {
            const selectable = v.name === chosen || canAssign(v.name, state.slots, i);
            return `<button type=\"button\" class=\"dz-sw ${v.name === chosen ? 'dz-on' : ''}\" style=\"background:${silkBg(v.hex)}\" title=\"${v.name}${selectable ? '' : ' - none left for this set'}\" role=\"radio\" aria-checked=\"${v.name === chosen}\" data-slot=\"${i}\" data-colour=\"${v.name}\" ${selectable ? '' : 'disabled'}></button>`;
          }).join('')}
        </div>
      </div>`).join('');
    $('[data-dz-slots]').querySelectorAll('.dz-sw:not([disabled])').forEach(b => b.addEventListener('click', () => {
      state.active = parseInt(b.dataset.slot, 10);
      state.slots[state.active] = b.dataset.colour;
      state.galleryColour = b.dataset.colour;
      state.view = 0;
      render();
    }));
  }

  function renderSummary() {
    const t = tier();
    const BASE = S().base;
    const FREE_QTY = parseInt(attr('data-free-delivery-qty'), 10) || 2;
    const DELIVERY = parseFloat(attr('data-delivery-cost')) || 0;
    const subtotal = t.each * t.qty;
    const saving = BASE * t.qty - subtotal;
    const free = t.qty >= FREE_QTY;
    const total = subtotal + (free ? 0 : DELIVERY);
    const counts = {};
    state.slots.forEach(c => counts[c] = (counts[c] || 0) + 1);
    const lines = Object.entries(counts).map(([c, n]) => `<div class=\"dz-sum-row\"><span class=\"dz-muted\">${n} \u00d7 ${c}</span><span>${fmt(t.each * n)}</span></div>`).join('');
    $('[data-dz-summary]').innerHTML = `${lines}
      ${saving > 0 ? `<div class=\"dz-sum-row dz-savings\"><span>You save vs single price</span><span>-${fmt(saving)}</span></div>` : ''}
      <div class=\"dz-sum-row dz-delivery\"><span class=\"dz-muted\">UK delivery</span><span class=\"${free ? 'dz-free' : ''}\">${free ? 'Free' : fmt(DELIVERY)}</span></div>
      <div class=\"dz-sum-total\"><span>You pay today</span><span>${fmt(total)}</span></div>
      ${!free ? `<div class=\"dz-delivery-nudge\">Add a second mask to unlock free delivery and save ${fmt(BASE - S().tiers[1].each)}</div>` : ''}`;
    $('[data-dz-atc]').textContent = `Add to bag - ${fmt(total)}`;
    const sb = document.querySelector('[data-dz-sticky]');
    if (sb) {
      const saveEl = sb.querySelector('[data-dz-sb-save]');
      const btn = sb.querySelector('[data-dz-sticky-atc]');
      if (saveEl) {
        if (saving > 0) { saveEl.textContent = `You save ${fmt(saving)} (${t.save}%)`; saveEl.hidden = false; }
        else { saveEl.textContent = ''; saveEl.hidden = true; }
      }
      if (btn) btn.textContent = `Checkout \u00b7 ${fmt(total)}`;
    }
  }

  function renderGallery() {
    const colour = state.galleryColour || state.slots[0];
    const views = S().views[colour] || [];
    if (state.view >= views.length) state.view = 0;
    const main = document.getElementById('dz-hero-media');
    if (main && views[state.view] && views[state.view].src) {
      main.removeAttribute('srcset'); main.removeAttribute('sizes');
      main.src = views[state.view].src;
      main.alt = colour + ' ' + views[state.view].label;
    }
    const cap = document.querySelector('.dz-hero-caption');
    if (cap) cap.textContent = colour + (views[state.view] ? ' \u00b7 ' + views[state.view].label : '');
    const vEl = document.querySelector('[data-dz-views]');
    if (vEl) {
      vEl.innerHTML = views.map((v, i) => `<button type=\"button\" class=\"dz-thumb ${i === state.view ? 'dz-on' : ''}\" data-view=\"${i}\" aria-label=\"${colour} ${v.label}\"><img src=\"${v.thumb || ''}\" alt=\"${colour} ${v.label}\" loading=\"lazy\"><span>${v.label}</span></button>`).join('');
      vEl.querySelectorAll('.dz-thumb').forEach(b => b.addEventListener('click', () => { state.view = parseInt(b.dataset.view, 10); renderGallery(); }));
    }
    const cEl = document.querySelector('[data-dz-colours]');
    if (cEl) {
      cEl.innerHTML = S().variants.map(v => `<button type=\"button\" class=\"dz-cthumb ${v.name === colour ? 'dz-on' : ''}\" data-colour=\"${v.name}\" aria-label=\"${v.name}\" title=\"${v.name}\"><img src=\"${(S().views[v.name] && (S().views[v.name][0].thumb || S().views[v.name][0].src)) || ''}\" alt=\"${v.name}\" loading=\"lazy\"></button>`).join('');
      cEl.querySelectorAll('.dz-cthumb').forEach(b => b.addEventListener('click', () => {
        state.galleryColour = b.dataset.colour;
        state.view = 0;
        renderGallery();
      }));
    }
    const lab = document.querySelector('[data-dz-strip-label]');
    if (lab) lab.textContent = `All ${S().variants.length} silks`;
  }

  function render() { renderStepper(); renderSlots(); renderSummary(); renderGallery(); }

  $('[data-dz-minus]').addEventListener('click', () => setQty(state.qty - 1));
  $('[data-dz-plus]').addEventListener('click', () => setQty(state.qty + 1));

  const tog = document.querySelector('[data-dz-styles]');
  if (tog) {
    if (!STYLES.threed) {
      tog.style.display = 'none';
      const lab = tog.previousElementSibling;
      if (lab && lab.classList.contains('dz-bb-label')) lab.style.display = 'none';
    } else {
      tog.querySelectorAll('.dz-style').forEach(b => b.addEventListener('click', () => setStyle(b.dataset.style)));
    }
  }

  /* ---- style pre-select from other sections (e.g. Flat vs 3D cards) ---- */
  document.querySelectorAll('[data-dz-choose]').forEach(el => el.addEventListener('click', () => {
    if (STYLES[el.dataset.dzChoose]) setStyle(el.dataset.dzChoose);
  }));

  /* ---- Add to cart: group duplicate colours into quantity per variant ---- */
  async function addToBag(goCheckout, btn) {
    const err = $('[data-dz-error]');
    const counts = {};
    state.slots.forEach(n => { const id = byName(n).id; counts[id] = (counts[id] || 0) + 1; });
    const items = Object.entries(counts).map(([id, quantity]) => ({ id: parseInt(id, 10), quantity }));
    const label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding\u2026'; if (err) err.hidden = true;
    try {
      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (!goCheckout && drawer) body.sections = 'cart-drawer,cart-icon-bubble';
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to bag');
      const data = await res.json();
      if (goCheckout) { window.location.href = '/checkout'; return; }
      if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(data); }
      else { window.location.href = '/cart'; }
    } catch (e) {
      if (err) { err.textContent = e.message; err.hidden = false; }
      btn.textContent = label;
    } finally {
      btn.disabled = false; renderSummary();
    }
  }

  $('[data-dz-atc]').addEventListener('click', () => addToBag(false, $('[data-dz-atc]')));
  const stickyBtn = document.querySelector('[data-dz-sticky-atc]');
  if (stickyBtn) stickyBtn.addEventListener('click', () => addToBag(true, stickyBtn));

  /* ---- sticky bar ---- */
  const sticky = document.querySelector('[data-dz-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => sticky.classList.toggle('dz-show', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(root);
  }

  render();
})();
